module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "TOC"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_vm._v(" Table of Contents ")]), _vm._v(" "), _c('p', {
    staticClass: "tocsec",
    attrs: {
      "id": "forward"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005foreword"
    }
  }, [_c('strong', [_vm._v("FOREWORD")]), _vm._v(" by Andrew Wagner")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec",
    attrs: {
      "id": "introduction"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006introduction"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec",
    attrs: {
      "id": "part1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007part1"
    }
  }, [_c('strong', [_vm._v("SECTION 1: INTERIORS")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter1"
    }
  }, [_vm._v("Surfaces")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/009chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lighting")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/010chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kitchen")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bath")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Case Goods")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seating")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Color")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lofts")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec",
    attrs: {
      "id": "part2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SECTION 2: EXTERIORS")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Landscaping")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/018chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rooflines")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cladding")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/020chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Windows + Doors")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/021chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Systems")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/022chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outdoor Furnishings")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/023chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leisure")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec",
    attrs: {
      "id": "part3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/024part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SECTION 3: ACCESSORIES")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/025chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Children")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/026chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Books + Music")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/027chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pets")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec",
    attrs: {
      "id": "epilogue"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/028epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("EPILOGUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    attrs: {
      "href": "#/002abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ABOUT THE AUTHORS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    attrs: {
      "href": "#/029copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("COPYRIGHT")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23296406","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004toc.vue
// module id = 63
// module chunks = 0